exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.what-is-log-deta { margin-top: 20px;}\r\n.what-is-log-deta h2 {  font-size: 24px; font-family: 'Montserrat'; color: #163B4F; margin: 0 auto; padding-bottom: 10px; border-bottom: 1px solid #C5CED3;}\r\n.what-is-log-deta h5 {  font-size: 17px; font-family: 'Montserrat'; color: #00AFE9; margin: 25px auto;}\r\n.what-is-log-deta p {   font-size: 16px; font-family: 'Hind'; color: #767776; margin-bottom: 20px; text-align: justify;}\r\n.what-type-log p { margin-bottom: 5px;}\r\n.what-type-log { padding: 20px 10px 20px 40px; background: #eeeeee; margin-bottom: 20px;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/what-is-log/what-is-log.component.css
// module id = ../../../../../src/app/what-is-log/what-is-log.component.css
// module chunks = main